angular.module('wbControllers').controller 'PlanController',
['$scope', '$location', '$routeParams', '$timeout', 'railsResource', 'plans'
($scope, $location, $routeParams, $timeout, $resource, plans) ->
  $scope.editPlan = false

  $scope.add = (first, second) ->
    Number(first) + Number(second)

  plan = null
  updateData = (data) ->
    return unless data?
    plan = plans.newPlan(data)
    $scope.urls = {}
    $scope.sharing = false
    $scope.planData = plans.calculatePlanData(plan)
    $scope.planData.forEach (d) -> d.year = d.month/12
    $scope.planData = _.sample($scope.planData, 500)

    if $location.path() is '/plans'
      plans.save plan
    $scope.retirement = plans.calculateRetirementInfo(plan)
    end = plan.planEnd
    gradientOffset = (plan.retirementAge*12 - plan.age*12 + 1)/(end*12 - plan.age*12)
    $scope.gradient = [
      { offset: "0%", color: '#00B298' },
      { offset: "#{gradientOffset*100}%", color: '#21bca5' }
      { offset: "#{gradientOffset*100}%", color: '#00B298' }
    ]
    $scope.ageTicks = [plan.age, plan.retirementAge, plan.planEnd]

  if data = $routeParams.data
    if angular.isString(data)
      $scope.plan = JSON.parse(atob(params.data))

  $scope.savingsFilter = (data) ->
    savings = _.map(data, 'savings')
    maxSavings = _.max(savings)
    savings.push maxSavings * 1.2
    savings

  $scope.$watch 'plan', updateData, true
]
